import stammdatenService from '../services/stammdatenService.js';
import {
    debounce,
} from '../util.js';

// Speichervorgänge laufen nacheinander, damit sich keine Requests überholen.
let speicherKette = Promise.resolve();

const speichereDebounceUnternehmen = debounce(() => {
	speicherKette = speicherKette.then(async () => {
		// Es wird immer der aktuelle Stand aus dem Cache gesendet (enthält alle bisherigen Änderungen).
		const erfolg = await stammdatenService.updateUnternehmensdaten(stammdatenService.unternehmen);
		if (!erfolg) {
			// Bei einem Fehler zeigen wir wieder den Serverstand an, damit Oberfläche und Datenbank nicht abweichen.
			await stammdatenService.holeUnternehmensdaten(true);
		}
	});
});

/**
 * Übernimmt die Änderung sofort in den Cache und speichert verzögert (debounce).
 * Der sofortige Cache-Update verhindert, dass schnell aufeinanderfolgende Änderungen
 * (z.B. mehrere Checkboxen) den Stand der vorherigen Änderung überschreiben.
 * @param {object} unternehmen Unternehmensobjekt inklusive der Änderung
 */
function updateDebounceUnternehmen(unternehmen) {
	stammdatenService.unternehmen = unternehmen;
	stammdatenService.unternehmenVersion++;
	speichereDebounceUnternehmen();
}

export {
	updateDebounceUnternehmen,
};
